import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";

export default function standart() {}

export async function fillDetail() {
  if (window.$catalog_measures_selectedRow.identification != undefined) {
    await omnimap
      .GetRelationAction(
        window.$catalog_measures_selectedRow.identification,
        1,
        100,
        window.$catalog_management_units_token
      )
      .then((result) => {
        $("#grootboek-nummer").html("");
        $("#discipline").html("");
        var grootboekCounter = 0;
        if (result.meta.total_found > 0) {
          result.data.forEach((relation) => {
            if (
              relation.relationships.related_instance_definition.code ==
                "GROOTBOEKNUMMER" &&
              grootboekCounter == 0
            ) {
              $("#grootboek-nummer").html(
                relation.relationships.related_instance.name
              );
              window.$catalog_measures_grootboek_nummer.text =
                relation.relationships.related_instance.name;
              window.$catalog_measures_grootboek_nummer.id =
                relation.relationships.related_instance.identification;
              window.$catalog_measures_grootboek_nummer.definitions =
                relation.identification;
              grootboekCounter++;
            }

            if (
              relation.relationships.related_instance_definition.code ==
              "DISCIPLINE"
            ) {
              $("#discipline").html(
                relation.relationships.related_instance.name
              );
              window.$catalog_measures_discipline.text =
                relation.relationships.related_instance.name;
              window.$catalog_measures_discipline.id =
                relation.relationships.related_instance.identification;
              window.$catalog_measures_discipline.definitions =
                relation.identification;
            }
          });
        } else {
          $("#grootboek-nummer").html("");
          $("#discipline").html("");
        }
      });
  }

  $("#naam").html(window.$catalog_work_plans_selectedRow.algemeenNaam);
  $("#naam-tooltip").html(window.$catalog_measures_selectedRow.algemeenNaam);
  $("#code").html(window.$catalog_measures_selectedRow.algemeenCode);
  $("#bestekspost").html(window.$catalog_measures_selectedRow.bestekspost);
  $("#raw-hoofdcode").html(window.$catalog_measures_selectedRow.rawhoofdcode);
  $("#raw-deficode").html(window.$catalog_measures_selectedRow.rawdeficode);
  $("#eenheidsprijs").html(window.$catalog_measures_selectedRow.eenheidsprijs);
  $("#eenheid").html(window.$catalog_measures_selectedRow.eenheid);
  $("#btw-percentage").html(
    window.$catalog_measures_selectedRow.algemeenBtwpercentage
  );
  $("#kwaliteit").html(window.$catalog_measures_selectedRow.kwaliteit);
  $("#omschrijving").html(window.$catalog_measures_selectedRow.omschrijving);
  $("#periode-voorkeur").html(
    window.$catalog_measures_selectedRow.algemeenPeriodevoorkeurIdentification
  );
  $("#patroon-voorkeur").html(
    window.$catalog_measures_selectedRow.algemeenPatroonvoorkeurIdentification
  );

  $("#omschrijving-tooltip").html(
    window.$catalog_measures_selectedRow.omschrijving
  );
  $("#percentage").html(
    window.$catalog_measures_selectedRow.algemeenpercentage
  );
  if (window.$catalog_measures_selectedRow.isActive)
    $("#maatregelen_active").attr("checked", "checked");
  else $("#maatregelen_active").removeAttr("checked");

  /***Edit Side */
  $("#e-naam").val(window.$catalog_measures_selectedRow.algemeenNaam);
  $("#e-code").val(window.$catalog_measures_selectedRow.algemeenCode);
  $("#e-bestekspost").val(window.$catalog_measures_selectedRow.bestekspost);
  $("#e-raw-hoofdcode").val(window.$catalog_measures_selectedRow.rawhoofdcode);
  $("#e-raw-deficode").val(window.$catalog_measures_selectedRow.rawdeficode);
  $("#e-eenheidsprijs").val(window.$catalog_measures_selectedRow.eenheidsprijs);
  $("#e-percentage").val(
    window.$catalog_measures_selectedRow.algemeenpercentage
  );

  $("#e-eenheid-select").val(window.$catalog_measures_selectedRow.eenheid);
  var e_eenheid = $("#e-eenheid");
  e_eenheid[0].childNodes.forEach((element) => {
    element.textContent == window.$catalog_measures_selectedRow.eenheid
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });

  // $("#e-eenheid").val(window.$catalog_measures_selectedRow.eenheid);
  $("#e-kwaliteit-select").val(window.$catalog_measures_selectedRow.kwaliteit);
  var kwaliteit = $("#e-kwaliteit");
  kwaliteit[0].childNodes.forEach((element) => {
    element.textContent == window.$catalog_measures_selectedRow.kwaliteit
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });
  $("#e-btw-percentage-select").val(
    window.$catalog_measures_selectedRow.algemeenBtwpercentage
  );
  var btwPercentage = $("#e-btw-percentage");
  btwPercentage[0].childNodes.forEach((element) => {
    element.textContent ==
    window.$catalog_measures_selectedRow.algemeenBtwpercentage
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });
  $("#e-grootboek-nummer-select").val(
    window.$catalog_measures_grootboek_nummer.text
  );
  var grootboekNummer = $("#e-grootboek-nummer");
  grootboekNummer[0].childNodes.forEach((element) => {
    element.id == window.$catalog_measures_grootboek_nummer.id
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });
  $("#e-discipline-select").val(window.$catalog_measures_discipline.text);
  var discipline = $("#e-discipline");
  discipline[0].childNodes.forEach((element) => {
    element.id == window.$catalog_measures_discipline.id
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });

  $("#e-periode-voorkeur-select").val(
    window.$catalog_measures_selectedRow.algemeenPeriodevoorkeurIdentification
  );
  var periodeVoorkeur = $("#e-periode-voorkeur");
  periodeVoorkeur[0].childNodes.forEach((element) => {
    element.textContent ==
    window.$catalog_measures_selectedRow.algemeenPeriodevoorkeurIdentification
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });

  $("#e-patroon-voorkeur-select").val(
    window.$catalog_measures_selectedRow.algemeenPatroonvoorkeurIdentification
  );
  var patroonVoorkeur = $("#e-patroon-voorkeur");
  patroonVoorkeur[0].childNodes.forEach((element) => {
    element.textContent ==
    window.$catalog_measures_selectedRow.algemeenPatroonvoorkeurIdentification
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });

  $("#e-omschrijving").val(window.$catalog_measures_selectedRow.omschrijving);
  if (window.$catalog_measures_selectedRow.isActive)
    $("#e-maatregelen_active").attr("checked", "checked");
  else $("#e-maatregelen_active").removeAttr("checked");

  $("#e-identification").val(
    window.$catalog_measures_selectedRow.identification
  );
}

export function GetColumnProperties(callType) {
  omnimap
    .GetColumnPropertiesAction(window.$catalog_management_units_token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesCallBack(result, callType);
      // fillDetail();
    });
}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {
  omnimap
    .OmnimapPost(model, pageNr, pageSize, token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesForModelCallBack(
        result,
        itemId,
        callType
      );
    })
    .catch((error) => {
      console.log(error);
    });
}

export const rowsHandleDelete = () => {
  // 1. bu kayıtın relationlarını getir.
  // 2. tüm relationlarını sil.
  // 3. sonra kayıtı sil.
  $("#cover-spin").show(0);
  window.$catalog_work_plans_selectedIds.forEach(async (element) => {
    let realtions = await omnimap.GetRelationAction(
      element,
      1,
      30,
      window.$catalog_management_units_token
    );

    if (realtions.data !== undefined) {
      await realtions.data.forEach(async (relation) => {
        let result = await omnimap
          .DeleteRelationAction(
            relation.identification,
            window.$catalog_management_units_token
          )
          .catch((error) => {
            console.log(error);
          });
        var test = "";
      });
    }

    GC.sleep(2000).then(async () => {
      let result = await omnimap
        .Delete(element, window.$catalog_management_units_token)
        .catch((error) => {
          console.log(error);
        });

      CallBackFunctions.RowsDeletedCallBack(
        window.$catalog_management_units_token
      );
    });
  });
};

export const GetMedia = (rowId) => {
  return new Promise(function (resolve, reject) {
    fetch(
      `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/media/${rowId}/content`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: "Bearer " + window.$catalog_management_units_token,
          tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
          organisation_identification:
            process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
        },
      }
    )
      .then((response) => response.blob())
      .then((images) => {
        // Then create a local URL for that image and print it
        var outside = URL.createObjectURL(images);
        // this.setState({ gettingMedia: outside });
        resolve(outside);
      })
      .catch((err) => alert(err));
  });
};

export const UpdateAttachmentCount = async (attachmentCount) => {
  const model = [
    {
      op: "add",
      path: "/content/algemeen/aantalbijlagen",
      value: attachmentCount,
    },
  ];
  await omnimap.PatchMethodAction(
    model,
    window.$catalog_work_plans_selectedRow.identification,
    false,
    window.$catalog_management_units_token
  );

  const loadModel = {
    definitions: [process.env.REACT_APP_CATALOG_WORK_PLANS],
  };

  GC.sleep(3000).then(() => {
    window.$catalog_work_plans_refresh();
    /*omnimap
      .FillTableAction(loadModel, 1, window.$catalog_management_units_token)
      .then((result) => CallBackFunctions.FillTableCallBack(result, 1, window.$catalog_work_plans_columListPure));*/
  });
};
